export type HospitalVisit = {
  hospitalVisitId: number;
  visitDate: Date;
  visitTime: Date;
  hospitalName: string;
  purpose: string;
  modifiedDate: Date;
};

export enum TreatmentStatus {
  Suspend = 1,
  Resume = 2,
  Finish = 3,
}

export type Treatment = {
  treatmentValue: number;
  treatmentName: string;
  status: TreatmentStatus;
  detail: string;
  diseaseName: string;
  startDate: Date;
  suspensionDate: Date;
  modifiedDate: Date;
};

export type Diagnosis = {
  diseaseName: string;
  hasRecord: boolean;
};

export type ExerciseHabit = {
  exerciseRoutineOptionId: number | null;
  exerciseRoutine: string | null;
  modifiedDate: Date | null;
};
